import React, { useState, useEffect } from 'react'
import { Row, Col, Card, Button, Alert, Menu, Avatar, Tabs } from 'antd'
import './Dashboard.css';
import { HeatMapOutlined, CommentOutlined, PaperClipOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { AssesmentUrl } from '../Constants/Constants';
import axios from 'axios';
import { Table } from 'antd'
import { useLocation } from 'react-router-dom';
import { notification } from 'antd';
import EventModal from './EventModal';
import { BaseUrl } from "../Constants/Constants";
import {CareerProgressCard , AssessmentStatusCard} from "../Dashboard/StatusCard"

const Dashboard = () => {
    const navigate = useNavigate();
    const [allData, setAllData] = useState([])
    const [email, setEmail] = useState('');
    const location = useLocation();

    const profileDetails = JSON.parse(localStorage.getItem("Profile"));
    const userId = profileDetails?.user_id;

    const [upcomingPage, setUpcomingPage] = useState(1);
    const [attendPage, setAttendPage] = useState(1);
    const pageSize = 3;

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fromAttendTab, setFromAttendTab] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [loadingEvents, setLoadingEvents] = useState(true);
    const [error, setError] = useState("");

    const [eventsToAttend, setEventsToAttend] = useState([]);
    const [loadingAttendEvents, setLoadingAttendEvents] = useState(true);

    useEffect(() => {
        const profile = localStorage.getItem("Profile");
        if (profile) {
            const parsedProfile = JSON.parse(profile);
            setEmail(parsedProfile.email);
            console.log(email, "email");
        }
    }, []);

    useEffect(() => {
        if (location.state?.message) {
            notification.success({
                message: "Success",
                description: location.state.message,
            });
        }
    }, [location]);

    // --- 🔹 Fetch Upcoming Events Function ---
    const fetchUpcomingEvents = async () => {
        setLoadingEvents(true);
        try {
            const response = await axios.get(
                `${BaseUrl}event-user-mapping/assigned-events/${userId}`,
                { withCredentials: true }
            );

            if (response.data.status === "Ok" && response.data.statuscode === 200) {
                const events = response.data.data.events.map((item, index) => ({
                    key: index + 1,
                    event_management_id: item.event?.event_management_id,
                    eventName: item.event?.main_name,
                    eventTopic: item.event?.topic,
                    trainer: item.event?.trainer,
                    type: item.event?.type,
                    start_date: new Date(item.event?.start_date).toLocaleDateString("en-IN"),
                    end_date: new Date(item.event?.end_date).toLocaleDateString("en-IN"),
                    timing: item.event?.timing,
                    location: item.event?.location,
                    link: item.event?.link,
                    access_type: item.event?.access_type,
                    min_participants: item.event?.min_participants,
                    max_participants: item.event?.max_participants,
                    status: item.event?.status,
                    mandatory: item.event?.mandatory === true,
                    course_id: item.event?.course_id,
                    course_name: item.event?.course_name,
                    user_response: item.userResponse?.response,
                    attendance_status: item.attendance_status,
                    registered_users_count: item.event?.registered_users_count
                }));

                setUpcomingEvents(events);
            } else {
                setUpcomingEvents([]);
            }
        } catch (err) {
            console.error("Error fetching upcoming events:", err);
            setError("Failed to fetch events");
        } finally {
            setLoadingEvents(false);
        }
    };

    // --- 🔹 Fetch Events to Attend Function ---
    const fetchEventsToAttend = async () => {
        setLoadingAttendEvents(true);
        try {
            if (!userId) {
                console.error("No user ID found in localStorage");
                setLoadingAttendEvents(false);
                return;
            }

            const response = await axios.get(
                `${BaseUrl}event-user-mapping/active-events-from-response/${userId}`,
                { withCredentials: true }
            );

            if (response.data.status === "Ok" && response.data.statuscode === 200) {
                const events = response.data.data.events.map((item, index) => ({
                    key: index + 1,
                    event_management_id: item.event?.event_management_id,
                    eventName: item.event?.main_name,
                    eventTopic: item.event?.topic,
                    trainer: item.event?.trainer,
                    type: item.event?.type,
                    start_date: new Date(item.event?.start_date).toLocaleDateString("en-IN"),
                    end_date: new Date(item.event?.end_date).toLocaleDateString("en-IN"),
                    timing: item.event?.timing,
                    location: item.event?.location,
                    link: item.event?.link,
                    access_type: item.event?.access_type,
                    min_participants: item.event?.min_participants,
                    max_participants: item.event?.max_participants,
                    status: item.event?.status,
                    mandatory: item.is_mandatory === true,
                    course_id: item.event?.course_id,
                    course_name: item.event?.course_name,
                    user_response: item.userResponse?.response,
                    registered_users_count: item.event?.registered_users_count
                }));

                setEventsToAttend(events);
            } else {
                setEventsToAttend([]);
            }
        } catch (err) {
            console.error("Error fetching events to attend:", err);
        } finally {
            setLoadingAttendEvents(false);
        }
    };

    // --- Initial Data Fetch ---
    useEffect(() => {
        fetchUpcomingEvents();
    }, []);

    useEffect(() => {
        fetchEventsToAttend();
    }, []);

    // 🔹 View Event Modal
    const handleView = (event, fromAttend = false) => {
        setSelectedEvent(event);
        setFromAttendTab(fromAttend);
        setIsModalVisible(true);
    };

    // --- 🔹Updating user Accept/Reject for non-mandatory Events  ---
    const handleEventResponse = async (responseType) => {
        if (!selectedEvent || !userId) return;

        try {
            const payload = {
                event_management_id: selectedEvent.event_management_id,
                user_id: userId,
                response: responseType,
            };

            const res = await axios.post(
                `${BaseUrl}event-management/submit-event-response`,
                payload,
                { withCredentials: true }
            );

            if (res.data.status === "Ok") {
                notification.success({
                    message: `Event ${
                        responseType === "accept" ? "Accepted" : "Rejected"
                    }`,
                    description: `You have successfully ${responseType}ed the event.`,
                });

                // 🔹 Refetch both APIs to update the tables
                await Promise.all([
                    fetchUpcomingEvents(),
                    fetchEventsToAttend()
                ]);

            } else {
                notification.error({
                    message: "Error",
                    description: res.data.message || "Failed to submit response",
                });
            }
        } catch (err) {
            console.error("Error submitting response:", err);
            notification.error({
                message: "Error",
                description: "Something went wrong while submitting your response",
            });
        } finally {
            setIsModalVisible(false);
            setSelectedEvent(null);
        }
    };

    const handleAccept = () => {
        console.log(`Accepted event: ${selectedEvent.eventName}`);
        handleEventResponse("accept");
    };

    const handleReject = () => {
        console.log(`Rejected event: ${selectedEvent.eventName}`);
        handleEventResponse("not_accept");
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setSelectedEvent(null);
    };

    // ---- Reusable Event Column Function ----
    const getEventColumns = (eventData, currentPage, fromAttendTab) => [
        {
            title: "Event Name",
            dataIndex: "eventName",
            key: "eventName",
            align: "center",
            onCell: (record, rowIndex) => {
                const currentPageData = eventData.slice(
                    (currentPage - 1) * pageSize,
                    currentPage * pageSize
                );
                const sameEventCount = currentPageData.filter(
                    (e) => e.eventName === record.eventName
                ).length;
                const firstIndex = currentPageData.findIndex(
                    (e) => e.eventName === record.eventName
                );
                return rowIndex === firstIndex
                    ? { rowSpan: sameEventCount }
                    : { rowSpan: 0 };
            },
            width: 130,
        },
        {
            title: "Event Topic",
            dataIndex: "eventTopic",
            key: "eventTopic",
            align: "center",
            width: 150,
        },
        {
            title: "Event Type",
            dataIndex: "type",
            key: "type",
            align: "center",
            width: 120,
        },
        {
            title: "Start_Date",
            dataIndex: "start_date",
            key: "start_date",
            align: "center",
            width: 120,
        },
        {
            title: "Expand",
            key: "expand",
            align: "center",
            render: (_, record) => (
                <Button type="link" onClick={() => handleView(record, fromAttendTab)}>
                    View
                </Button>
            ),
        },
    ];

    const eventTabs = [
        {
            key: "1",
            label: "Upcoming Events",
            children: (
                <div className="Upcoming">
                    {loadingEvents ? (
                        <p style={{ textAlign: "center", padding: 20 }}>Loading...</p>
                    ) : upcomingEvents.length === 0 ? (
                        <p
                            style={{
                                textAlign: "center",
                                padding: 20,
                                color: "#888",
                                fontSize: 16,
                            }}
                        >
                            No Upcoming Events
                        </p>
                    ) : (
                        <Table
                            bordered
                            dataSource={upcomingEvents}
                            columns={getEventColumns(upcomingEvents, upcomingPage, false)}
                            pagination={{
                                current: upcomingPage,
                                pageSize: pageSize,
                                total: upcomingEvents.length,
                                onChange: (page) => setUpcomingPage(page),
                                showSizeChanger: false,
                                position: ["bottomCenter"],
                            }}
                        />
                    )}
                </div>
            ),
        },
        {
            key: "2",
            label: "Events to Attend",
            children: (
                <div className="Upcoming">
                    <Table
                        bordered
                        loading={loadingAttendEvents}
                        dataSource={eventsToAttend}
                        columns={getEventColumns(eventsToAttend, attendPage, true)}
                        pagination={{
                            current: attendPage,
                            pageSize: pageSize,
                            total: eventsToAttend.length,
                            onChange: (page) => setAttendPage(page),
                            showSizeChanger: false,
                            position: ["bottomCenter"],
                        }}
                    />
                </div>
            ),
        },
    ];

    const onChange = (key) => {
        console.log(key);
    };

    return (
        <div className='Dashboard-main'>
            <div className='dashboardGrid'>
                {/* ROW 1: Career Status + Assessment Status */}
                <div className='dashboardCardMedium'>
                    <CareerProgressCard/>
                </div>
                
                <div className='dashboardCardMedium'>
                    <AssessmentStatusCard/>
                </div>

                {/* ROW 2: Events Table + My Courses Coming Soon */}
                <div className='dashboardCardMedium'>
                    <Card className="dashboardCard activitiesCard">
                      <div className="activitiesCardHeader">
                        <h3 className="activitiesCardTitle">Events</h3>
                      </div>

                      <Alert
                        banner
                        message="All time information shown below is in IST format."
                        className="dashboardAlert"
                      />

                      <Tabs
                        defaultActiveKey="1"
                        items={eventTabs}
                        centered
                        onChange={onChange}
                        className="dashboardTabs"
                      />

                      <EventModal
                        isVisible={isModalVisible}
                        selectedEvent={selectedEvent}
                        onClose={handleModalClose}
                        onAccept={handleAccept}
                        onReject={handleReject}
                        fromAttendTab={fromAttendTab}
                      />
                    </Card>
                 </div>

                <div className='dashboardCardMedium'>
                    <Card className='dashboardCard progressCard'>
                        <div className='progressCardHeader'>
                            <h3 className='progressCardTitle'>My Courses & Trainings</h3>
                            <img className='comingSoonBadge' src='/icons/coming-soon-1.png' alt='coming soon' width={28} height={28} />
                        </div>
                        <div className='progressStats'>
                            <div className='progressStatItem'>
                                <p className='progressStatLabel'>In Progress</p>
                                <h3 className='progressStatValue'>-</h3>
                            </div>
                            <div className='progressStatItem'>
                                <p className='progressStatLabel'>Completed</p>
                                <h3 className='progressStatValue'>-</h3>
                            </div>
                            <div className='progressStatItem'>
                                <p className='progressStatLabel'>Incomplete</p>
                                <h3 className='progressStatValue'>-</h3>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default Dashboard